export default "__VITE_ASSET__CxIJ0xwN__"